import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { useState } from 'react';
import { useEffect } from 'react';
import { Button, Grid, Stack } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { EditAccountForm } from './EditAccountForm';
import useFetchJson from '../../../data/useFetchJson';

export function AccountsList({ accounts, onAccountEditComplete }) {

    console.log('AccountsList started with accounts', accounts)
    const [theAccounts, setTheAccounts] = useState(accounts)
    const [editAccountId, setEditAccountId] = useState(null)
    const [editedAccount, setEditedAccount] = useState(null) // {account, name, email, phone}

    const patchAccountBaseUrl = '/bff/user-management-service-mahi/api/accounts'
    const {
        load: patchAccount,
        // isLoading: isAccountPatching,
        // data: postRFIResponse
    } = useFetchJson(patchAccountBaseUrl, { method: 'PATCH' }, false)

    useEffect(() => {
        setTheAccounts(accounts)
    }, [accounts])

    const handleAccountChanged = (accountDetails) => {
        console.log(`handleAccountChanged()`, { accountDetails })
        setEditedAccount(accountDetails)
    }

    const handleEditClick = (accountDetails) => {
        console.log(`handleEditClick()`, { accountDetails })
        setEditAccountId(accountDetails.accountId)
    }

    const handleSaveClick = async () => {
        console.log(`handleSaveClick()`, { editedAccount })

        if (!editedAccount) {
            // Nothing changed?
            setEditAccountId(null)
            return
        }

        const options = {
            method: 'PATCH',
            headers: {},
            body: JSON.stringify(editedAccount),
        }
        const patchAccountFullUrl = `${patchAccountBaseUrl}/${editedAccount.accountId}/update-properties`
        const patchAccountResponse = await patchAccount(options, patchAccountFullUrl)

        if (patchAccountResponse !== undefined) {
            // Patch succeeded
            onAccountEditComplete(editedAccount)
        }

        setEditAccountId(null)
    }

    const handleEditCancelClick = (accountDetails) => {
        console.log(`handleEditCancelClick()`, { accountDetails })
        setEditAccountId(null)
    }


    return (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {
                theAccounts?.map((thisAccount) => {

                    return (
                        <Grid container spacing={2} key={thisAccount.accountId}>
                            <Grid item xs={6}>
                                <Box key={thisAccount.email}>
                                    {
                                        editAccountId === thisAccount.accountId ?
                                            <EditAccountForm accountChanged={handleAccountChanged} accountDetails={thisAccount} />
                                            :
                                            <AccountReadOnly accountDetails={thisAccount} />
                                    }


                                    <Divider variant="inset" component="li" />
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box>
                                    {
                                        editAccountId === thisAccount.accountId ?
                                            <>
                                                <Button variant="outlined" sx={{ my: 2.4, mx: 2 }} onClick={() => { handleEditCancelClick(thisAccount) }}>Cancel</Button>
                                                <Button variant="contained" sx={{ my: 2.4, mx: 2 }} onClick={handleSaveClick}>Save</Button>
                                            </>
                                            :
                                            <>
                                                <Button variant="outlined" sx={{ my: 2.4, mx: 2 }} onClick={() => { handleEditClick(thisAccount) }}>Edit</Button>
                                            </>
                                    }


                                </Box>
                            </Grid>
                        </Grid>
                    )
                })
            }
        </List>
    )
}

function AccountReadOnly({accountDetails}) {
    return (
        <ListItem alignItems="flex-start">
            <ListItemAvatar>
                <Avatar alt={accountDetails.name} />
            </ListItemAvatar>
            <Stack direction="column">
                <Typography variant="h6">{accountDetails.name}</Typography>
                <Typography variant="body2">{accountDetails.email}</Typography>
                <Typography variant="body2">{accountDetails.phone}</Typography>
                <Typography variant="body2">{accountDetails.accountId}</Typography>
                <Stack direction="row" alignItems="center">
                    {accountDetails?.notificationSettings?.recvEmailOnNewInspection  ?
                        <CheckIcon color="success" fontSize="small" /> :
                        <CloseIcon color="error" fontSize="small" />
                    }
                    <Typography variant="body2" >
                        Email on new Inspection
                    </Typography>
                </Stack>
            </Stack>
        </ListItem>
    )
}